<template>
  <div class="stat-card">
    <div class="stat-card__label">{{ label }}</div>
    <div class="stat-card__value">{{ value }}</div>
    <div class="stat-card__hint">{{ hint }}</div>
  </div>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
.stat-card {
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 20px;
  padding: 20px;
}

.stat-card__label {
  color: #6b7280;
  font-size: 14px;
}

.stat-card__value {
  margin-top: 10px;
  color: #111827;
  font-size: 28px;
  font-weight: 700;
}

.stat-card__hint {
  margin-top: 8px;
  color: #94a3b8;
  font-size: 12px;
}
</style>
